export default function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-stone px-4">
      <div className="card card-shadow max-w-md w-full p-8">
        <p className="mono-label text-brick mb-2">Error</p>
        <h1 className="hl text-2xl text-navy mb-3">Something broke</h1>
        <p className="text-navy/75 mb-6 leading-relaxed">
          Reload the page to carry on. If it keeps happening, write to hello@mvpclub.ai
          and tell us what you were doing.
        </p>
        <button onClick={() => window.location.reload()} className="btn btn-amber">
          Reload
        </button>
      </div>
    </div>
  )
}
